var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMonitorList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4375 7.53125H135.562C139.938 7.53125 143.5 11.093 143.5 15.4688V99.2812C143.5 103.657 139.938 107.219 135.562 107.219H8.4375C4.06177 107.219 0.5 103.657 0.5 99.2812V15.4688C0.5 11.093 4.06177 7.53125 8.4375 7.53125Z",
    fill: "url(#paint0_linear_2035_186)",
    stroke: "#00CC99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117 128.531H94.2188V116.156H49.7812V128.531H27C24.6713 128.531 22.7812 130.421 22.7812 132.75C22.7812 135.079 24.6713 136.969 27 136.969H117C119.329 136.969 121.219 135.079 121.219 132.75C121.219 130.421 119.329 128.531 117 128.531Z",
    fill: "#00CC99"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2035_186",
    x1: 72.2677,
    y1: 57.375,
    x2: 71.924,
    y2: 107.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9FFF9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMonitorList);
export default __webpack_public_path__ + "static/media/ICON_MONITOR_LIST.657de466e79a3aa8645d52dc25078d4c.svg";
export { ForwardRef as ReactComponent };